"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { ArrowUpRight, Wrench, Zap, Droplets, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const maintenanceServices = [{
  id: "BEFORE NSDB",
  title: "FORMATION & EXPÉRIENCE",
  description: "Le parcours des 2 fondateurs de la société est similaire du fait de leur proximité avec le terrain tout au long de leur 1ère expérience professionnelle chez Eiffage Construction. David : 10 ans d'expériences chantier successives (coffreur à conducteur de Travaux). Nicolas : diplôme d'ingénieur puis 5 ans de conduite de Travaux. En 2003, c'est la rencontre. Plus qu'une rencontre, c'est la même vision du métier, le partage des connaissances, l'entraide, la complicité. 5 ans de réel engagement pour un grand groupe du BTP sur des chantiers d'envergure, on apprend vite !",
  specs: ["GESTION DE CHANTIER TOUS CORPS D'ÉTATS", "RIGUEUR TECHNIQUE ET FINANCIÈRE", "CHANTIERS D'ENVERGURE"],
  image: "https://nsdb.10web.cloud/wp-content/uploads/2026/03/IMG_7216-1364x800-1.webp?v=9aa9hk5hyag",
  icon: Wrench
}, {
  id: "2008 : LE TOURNANT",
  title: "VOLONTÉ D'ENTREPRENDRE",
  description: "2008, la même ambition nous anime : entreprendre ! Nous créons Nouvelle Société Du Bâtiment (NSDB) à Lyon avec le double objectif : faire valoir notre expérience et nos compétences en gestion de projet auprès des promoteurs pour la construction de logements neufs ET constituer une équipe d'artisans / partenaires minutieusement sélectionnés pour faire bénéficier les particuliers de notre rigueur et de notre exigence dans l'exécution de travaux haut de gamme et sur-mesure. Notre secteur d'activité souffre d'une mauvaise réputation ? Notre ambition est de montrer que le secteur est aussi constitué de nombreux professionnels qui méritent d'être mis en valeur !",
  specs: ["CRÉATION EN 2008, SIÈGE À LYON", "AUTONOMIE ET INDÉPENDANCE", "RESEAU COMPLET D'ENTREPRISES & ARTISANS"],
  image: "https://nsdb.10web.cloud/wp-content/uploads/2026/03/Ecran_Lumiere_11-scaled.jpg?v=35l2k8j6mpk",
  icon: Zap
}, {
  id: "MAITRISE D'OEUVRE PAR NSDB",
  title: "Neuf & Rénovation",
  description: "Neuf ou Rénovation ? Les 2 ! Pourquoi ? Parce que les 2 nous intéresse ! Pour les particuliers, nous menons le projet de A à Z (du PC à la réception des travaux). Les travaux de rénovation sont souvent complexes et demandent une adaptabilité de tous les instants, c'est pourquoi notre présence est quasi quotidienne. Notre connaissance du bâti ancien et notre rigueur nous permettent également d'envisager les solutions permettant de privilégier le rendu final. Pour les promoteurs, l'exigence est notre règle d'or au coeur du pilotage des programmes neufs de logements. Piloter l'opération de la manière la plus lisble, faire adhérer les entreprises au projet et obtenir la satisfaction de vos acquéreurs sont nos objectifs quotidiens indispensables à la réussite de votre programme !",
  specs: ["PARTICULIERS : MOE COMPLÈTE", "PROMOTEURS : MOE EXE (DCE, DET, OPC...)", "EXPERTISE TECHNIQUE - RIGUEUR - EXIGENCE"],
  image: "https://nsdb.10web.cloud/wp-content/uploads/2026/03/20251128090642-scaled.jpg?v=4p1lmkt5bv",
  icon: Droplets
}];
export default function PropertyMaintenance() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="165192" id="expertisehistory" className="relative w-full bg-primary text-primary-foreground py-24 overflow-hidden border-y-2 border-secondary/20">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, var(--color-secondary) 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }}></div>

      <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10">
        
        {}
        <div ref={headerRef} className={`mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 border-b-2 border-secondary/30 pb-8 relative">
            {}
            <div className="absolute -bottom-[2px] left-0 w-4 h-[2px] bg-secondary"></div>
            
            <div className="max-w-2xl">
              <div className="flex items-center gap-4 mb-6">
                <span className="font-mono text-xs font-bold tracking-widest text-secondary bg-secondary/10 px-2 py-1">
                  DEPUIS 2008
                </span>
                <Separator orientation="vertical" className="h-4 bg-secondary/30" />
                <span className="font-mono text-xs tracking-widest text-secondary/70 uppercase">Maîtrise d'Œuvre NEUF &amp; RENOVATION</span>
              </div>
              <h2 className="font-sans text-4xl md:text-6xl font-black uppercase tracking-tighter text-primary-foreground mb-4">
                Expertise <br className="hidden md:block" /> & Histoire
              </h2>
              <p className="font-mono text-sm text-primary-foreground/80 max-w-md leading-relaxed">UNE PRÉSENCE QUOTIDIENNE DÉDIÉE AU PARTAGE DE TOUTE NOTRE EXPÉRIENCE ET NOTRE SAVOIR FAIRE POUR LE PILOTAGE PERSONNALISÉ DE VOS PROJETS DE CONSTRUCTION.</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 shrink-0">
              <Button asChild variant="outline" size="lg" className="rounded-none border-2 border-secondary/50 font-mono uppercase tracking-wider text-xs h-12 px-6 hover:bg-secondary hover:text-secondary-foreground transition-colors">
                
              </Button>
              <Button asChild size="lg" className="rounded-none font-mono uppercase tracking-wider text-xs h-12 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90">
                
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 border-l-2 border-t-2 border-secondary/20 bg-secondary/20 gap-[2px]">
          {maintenanceServices.map((service, index) => <Card key={service.id} data-index={index} className="rounded-none border-0 bg-primary flex flex-col group hover:bg-secondary/5 transition-colors duration-300">
              <div className="p-4 border-b-2 border-secondary/20 flex justify-between items-center bg-primary/50">
                <span className="font-mono text-xs font-bold text-secondary/60">
                  {service.id}
                </span>
                <service.icon className="size-4 text-secondary" />
              </div>
              
              <AspectRatio ratio={16 / 9} className="border-b-2 border-secondary/20 overflow-hidden bg-primary/20">
                <img src={service.image} alt={service.title} className="object-cover w-full h-full grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 border-[1px] border-secondary/30 m-4 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </AspectRatio>

              <CardHeader className="p-6 pb-4">
                <CardTitle className="font-sans text-2xl font-bold uppercase tracking-tight text-primary-foreground">
                  {service.title}
                </CardTitle>
                <CardDescription className="font-mono text-xs leading-relaxed mt-2 text-primary-foreground/60">
                  {service.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="p-6 pt-0 flex-grow">
                <div className="space-y-2">
                  <div className="font-mono text-[10px] text-secondary uppercase tracking-widest mb-3">
                    POINTS CLES
                  </div>
                  {service.specs.map((spec, i) => <div key={i} data-index={i} className="flex items-center gap-2 font-mono text-xs text-primary-foreground/90">
                      <div className="size-1 bg-secondary shrink-0"></div>
                      {spec}
                    </div>)}
                </div>
              </CardContent>

              
            </Card>)}
        </div>

        {}
        

      </div>
    </section>;
}